import React, { useState, useEffect } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Home.css";
import "./OurServices.css";
import OurServicesImage1 from "../assets/img/OurServicesImage1.png";
import OurServicesImage2 from "../assets/img/OurServicesImage2.png";
import OurServicesImage3 from "../assets/img/OurServicesImage3.png";

// Images Data
const imagesSlider = [
  {
    id: 1,
    img: OurServicesImage1,
    title: "Pulses",
    desc: "Pulses are the dry, edible seeds of legume plants, including lentils, beans, peas, and chickpeas.",
  },
  {
    id: 2,
    img: OurServicesImage2,
    title: "Pulses",
    desc: "Pulses use less water, enrich soil through natural nitrogen fixation, and lower carbon emissions",
  },
  {
    id: 3,
    img: OurServicesImage3,
    title: "Pulses Meal",
    desc: "Packed with protein, fiber, and essential nutrients, pulses support heart health, manage blood sugar.",
  },
];

const OurServices = () => {
  const [selectedImage, setSelectedImage] = useState(imagesSlider[0]);

  return (
    <div className="index-page">
      {/* Services Section */}
      <section
        className="services-section"
        style={{
          backgroundImage: `url(${selectedImage.img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          height: "500px",
          color: "white",
          transition: "background-image 0.5s ease-in-out",
        }}
      >
        {/* Overlay */}
        <div className="overlay"></div>

        {/* Content */}
        <div className="container text-left content" data-aos="fade-up">
          <h2 style={{ color: "#d4561a" }} className="title">
            {selectedImage.title}
          </h2>
          <p className="desc">{selectedImage.desc}</p>
        </div>

        {/* Thumbnails */}
        <div className="thumbnail-container" data-aos="zoom-in">
          {imagesSlider.map((item) => (
            <button
              key={item.id}
              className={`thumbnail-btn ${
                selectedImage.id === item.id ? "active" : ""
              }`}
              onClick={() => setSelectedImage(item)}
            >
              <img src={item.img} alt={item.title} className="thumbnail" />
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};

export default OurServices;
